export enum RouteTypeEmum {
  PRACTICAL_ROUTE = 'PM',
  HHG_ROUTE = 'HA'
}
